<template>
  <v-container id="integrations-view" tag="section">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="8" md="6">
            {{ $t('integrations.title') }}
          </v-col>
          <v-col cols="12" sm="4" md="6" class="text-sm-right">
            <v-btn color="primary" @click="createItemDialog">
              {{ $t('integrations.create') }}
            </v-btn>
            <v-btn color="secondary" @click="showParamsGenerator">
              {{ $t('integrations.button.parameters') }}
</v-btn>
            <v-btn color="secondary" @click="refreshItems">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
      <v-data-table :headers="headers" :loading="loading" :items="integrations" :items-per-page="25">
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon class="mr-2" v-on="on" @click="viewPublicKey = true">
                  mdi-eye
                </v-icon>
              </template>
              <span>{{ $t('integrations.view-pk') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon class="mr-2" v-on="on" @click="editItem(item)">
                  mdi-pencil-outline
                </v-icon>
              </template>
              <span>{{ $t('edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon v-on="on" @click="deleteItem(item)">
                  mdi-delete-outline
                </v-icon>
              </template>
              <span>{{ $t('delete') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-row justify="center">
      <v-dialog v-model="paramsGeneratorVisible" persistent max-width="600px">
        <params-generator
          ref="paramsGenerator"
          @cancel="hideParamsGenerator"
        />
      </v-dialog>
      <v-dialog v-model="editDialogVisible" persistent max-width="600px">
        <edit-integration
          v-if="editDialogVisible"
          :id="editedItemId"
          ref="integrationEditDialog"
          :model="editedItem"
          @cancel="closeEditDialog"
          @save="saveEditDialog"
        />
      </v-dialog>
      <v-dialog v-model="viewPublicKey" persistent max-width="600px">
        <div>
          <v-container id="classCreate">
            <v-card max-width="800px">
              <v-card-title>{{ $t('integrations.public-key') }}</v-card-title>
              <v-card-text>
                <pre>{{ publicKey }}</pre>
              </v-card-text>
              <v-card-actions>
                <v-btn color="blue darken-1" @click="viewPublicKey = false">
                  {{ $t('global.cancel') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </div>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { getIntegrationService } from '@/helpers/integrations'
  import EditIntegration from './components/EditIntegration.vue'
  import ParamsGenerator from './components/ParamsGenerator.vue'
  import view from '@/layouts/frontend/View.vue'
  export default {
    name: 'IntegrationsList',
    components: { EditIntegration, ParamsGenerator },
    data () {
      return {
        headers: [
          { text: this.$t('integrations.label.name'), align: 'name', sortable: true, value: 'name' },
          { text: this.$t('account.label.actions'), sortable: false, value: 'actions', align: 'end' },
        ],
        publicKey: '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqAjoDVoGM6oPDSN6OAkf\nYbwB83CUfqA8Z1tg+Z1nmLyEnqNsq4Ok+7zLBav3oiS3kX6BjwQZtOo7scgmpGz/\nMKLRgFcudNTQKxNRnYSqs1Yfro9p3t5eMZOJ8w31q0yXGEg75GYlBOGxoR60zeGj\n9QZqILnimlRmW75DyBIVOeQsHadUJ1SjZxMjIyDMh43VdlfX9Z5O265zvQHdI2HV\nNqHEKbnwP8EsKxpDdJ2PWV6XAGKCwTx4iisZY5UA1xoix45RhFkoVw3bP68HpWGt\nT27x7+lu/1BIawv854/3cxMMv1HnthaetN+rmLLO7kjJO6D4S9kzSsTp4+RFmftc\nRQIDAQAB\n-----END PUBLIC KEY-----',
        loading: false,
        integrations: [],
        editedItemId: '',
        editedItem: { key: '', ref: '' },
        editDialogVisible: false,
        viewPublicKey: false,
        paramsGeneratorVisible: false,
        integrationService: getIntegrationService(),
      }
    },
    computed: {
      view () {
        return view
      },
    },
    async mounted () {
      await this.refreshItems()
    },
    methods: {
      showParamsGenerator () {
        console.log('showParamsGenerator')
        this.paramsGeneratorVisible = true
      },
      hideParamsGenerator () {
        this.paramsGeneratorVisible = false
      },
      createItemDialog () {
        this.editDialogVisible = true
      },
      async refreshItems () {
        this.loading = true
        this.integrations = []
        this.integrations = await this.integrationService.get()
        this.loading = false
      },
      closeEditDialog () {
        this.editDialogVisible = false
        this.editedItemId = null
        this.editedItem = { key: '', ref: '' }
      },
      async saveEditDialog (integration) {
        this.editDialogVisible = false
        this.loading = true

        console.log(integration)

        if (integration.id) {
          const updatedIntegraiton = await this.integrationService.update(integration)
          if (updatedIntegraiton) {
            await this.refreshItems()
          }
        } else {
          const newIntegration = await this.integrationService.create(integration)
          this.integrations.push(newIntegration)
          this.loading = false
        }
        this.editedItemId = null
        this.editedItem = { key: '', ref: '' }
      },
      editItem (integration) {
        this.editedItemId = integration.id
        this.editedItem = integration
        this.editDialogVisible = true
      },
      async deleteItem (integration) {
        this.loading = true
        const newIntegrations = await this.integrationService.remove(integration.id)
        this.integrations = newIntegrations
        this.loading = false
      },
    },
  }
</script>
